import jQuery from 'jquery';
let $ = jQuery;

// ReSharper disable InconsistentNaming
function _mapSort(sort) {
    // ReSharper restore InconsistentNaming
    var rt;
    switch (sort) {
        case "hsn picks":
            rt = "default_sort";
            break;
        case "price-low-to-high":
            rt = "price(a)";
            break;
        case "price-high-to-low":
            rt = "price(d)";
            break;
        case "customer-rating":
            rt = "rating_sort";
            break;
        case "newest":
            rt = "new_arrivals";
            break;
        case "bestselling":
            rt = "best_sellers";
            break;
        default:
            rt = "default_sort";
            break;
    }
    return rt;
}

// ReSharper disable InconsistentNaming
function _getSpecialProductId(specialProductType) {
    // ReSharper restore InconsistentNaming
    var result;
    $.ajax
        (
        '/special-product-id/' + specialProductType,
        {
            context: this,
            dataType: 'json',
            async: false,
            success: function (data, status, xhr) {
                result = data;
            }
        }
        );
    return result;
}

// ReSharper disable InconsistentNaming
function _sendPostMessage(message) {
    // ReSharper restore InconsistentNaming
    if ((typeof (window.external) !== "undefined") && (typeof (window.external.notify) !== "undefined")) {
        window.external.notify(message + "::" + window.name);
    }
}

class Gap {
    constructor() {
        this.gapBusy = false;
        this.alertResponse = false;
        this.timer = null;
    }

    WaitForGap(callback) {
        var scope = this;
        if (this.gapBusy)
            this.timer = setTimeout(function () { scope.WaitForGap(callback); }, 500);
        else {
            if (this.alertResponse === true) {
                callback();
            }
        }
    }

    WaitForGapConfirm(callback, cancelCallback) {
        var scope = this;
        if (this.gapBusy)
            this.timer = setTimeout(function () { scope.WaitForGap(callback); }, 500);
        else {
            if (this.alertResponse === true) {
                callback();
            } else {
                cancelCallback();
            }
        }
    }

    ExecCommand(command) {
        if (HSN.Instance().DeviceInformation.IsWin8Metro === false) {
            document.location = command;
        }
        else {
            _sendPostMessage(command);
        }
        return false;
    }

    ConvertLink(href) {
        var host = document.location.host;
        return 'https://' + host + href;
    }

    FullyQualifyRelativeLink(url) {
        var host = document.location.host;
        var protocol = document.location.protocol;

        var urlRegex = new RegExp('^https?:\/\/', 'i');

        if (urlRegex.test(url)) {
            return url;
        }
        else {
            return protocol + '//' + host + url;
        }
    }

    BuildGapCommand(href) {
        var encodedHref = encodeURIComponent(href);

        if (href === '/' || href === this.FullyQualifyRelativeLink('/')) {
            return 'hsn://HSNWebView.PopToRoot/';
        }

        var searchRegex = new RegExp('^.*(/search/)(.*)/(.*)$', 'i');
        var matches = searchRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.Search/' + matches[3] + '/default_sort/none';
        }
        var specialProductRegex = new RegExp('^.*/(todays-special|on-air-now|hourly-deal|product-by-style)(.*)$', 'i');
        matches = specialProductRegex.exec(href);
        if (matches !== null) {
            //return 'hsn://HSNWebView.SpecialProduct/' + encodeURIComponent(matches[1] + matches[2]);
            var productInfo = _getSpecialProductId(matches[1] + matches[2]);
            if (productInfo && productInfo.WebPId !== 0) {
                return 'hsn://HSNWebView.Product/' + productInfo.Slug + '/' + productInfo.WebPId;
            }
            else {
                return 'hsn://HSNWebView.Product/';
            }
        }
        var newProductRegex = new RegExp('^.*(/products/)(.*)/(.*)$', 'i');
        matches = newProductRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.Product/' + matches[2] + '/' + matches[3];
        }
        var ensembleRegex = new RegExp('^.*(/ensemble/)(.*)/(.*)$', 'i');
        matches = ensembleRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.Ensemble/' + matches[2] + '/' + matches[3];
        }
        var shopRegex = new RegExp('(.+?)(/shop/)(.+)/([a-z0-9|_-]+)', 'i');
        matches = shopRegex.exec(href);
        if (matches !== null) {
            var sort = _mapSort(HSN.Instance().GetQueryStringParam(href, 'sort'));
            return 'hsn://HSNWebView.Search/' + matches[4] + '/' + sort + '/none';
        }
        var videoRegex = new RegExp('^.*(.mp4|.m4v)(.*)$', 'i');
        matches = videoRegex.exec(encodedHref);
        if (matches !== null) {
            return 'hsn://HSNWebView.PDVideo/' + matches[0] + "/" + matches[0];
        }
        var manualGapRegex = new RegExp('^.*(/app-link/)(.*)#(.*)$', 'i');
        matches = manualGapRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.' + matches[2] + '/' + encodeURIComponent(matches[3]);
        }
        var contentPageRegex = new RegExp('/content/.*/(\\d+\\??.*)', 'i');
        matches = contentPageRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.ContentPage/' + matches[1];
        }
        matches = href && href.indexOf('tel:') !== -1;
        if (matches) {
            return href;
        }
        var imagePageRegex = new RegExp('^//.*/is/image/', 'i');
        matches = imagePageRegex.exec(href);
        if (matches !== null) {
            if (HSN.Instance().DeviceInformation.IsIphone) {
                return 'hsn://HSNWebView.Image//' + window.location.protocol + encodedHref;
            }
            else {
                return 'hsn://HSNWebView.Goto//' + window.location.protocol + encodedHref;
            }
        }

        return 'hsn://HSNWebView.Goto//' + encodedHref;
    }

    PlayYouTubeVideo(youtubeVideoId) {
        var command = 'hsn://HSNWebView.YouTubeVideo/' + youtubeVideoId;
        this.ExecCommand(command);
        return;
    }

    PlayYouTubeVideoFromWebView (category, name, videoId) {
        var url = this.FullyQualifyRelativeLink('/youtube/' + category + '/' + name + '/' + videoId);
        var cmd = this.BuildGapCommand(url);
        this.ExecCommand(cmd);
        return;
    }

    CheckYouTubeSupport() {
        var command = 'hsn://HSNWebView.CheckYouTubeVideoSupport/';
        this.ExecCommand(command);
        return;
    }

    AddRemoveFavoriteProduct(pId, webId) {
        var command = 'hsn://HSNWebView.AddRemoveFavoriteProduct/' + pId + '/' + webId;
        this.ExecCommand(command);
        return;
    }

    AddRemoveFavoriteBrand(brandId) {
        var command = 'hsn://HSNWebView.AddRemoveFavoriteBrand/' + brandId;
        this.ExecCommand(command);
        return;
    }

    GoBack() {
        var command = 'hsn://HSNWebView.GoBack';
        this.ExecCommand(command);
        return;
    }

    Share(category, name, url) {
        var command = 'hsn://HSNWebView.Share/' + category + '/' + name + '/' + encodeURIComponent(url);
        this.ExecCommand(command);
        return;
    }

    GoToExternalBrowser(url) {
        var command = 'hsn://HSNWebView.GotoExtBrowser/' + encodeURIComponent(url);
        this.ExecCommand(command);
        return;
    }

};

const gap = new Gap();

export default gap;



// WEBPACK FOOTER //
// ./assets/js/mobile/Gap.js